import Actions from '../../odata/actions';

const actions = new Actions('twilioNumber', 'twilioNumbers');

export default actions;
